import React from "react";

const EscrowSolution = () => {
  return (
    <section className="escrow-solution-bg md:pt-[120px] pt-[60px] md:pb-[120px] pb-[60px]">
      <div className="container">
        <h3 className="text-[24px] md:text-[28px] md:max-w-[864px] text-center m-auto">
          Achieve <span className="text-cf-primary">3X</span> faster go-live
          <br className="hidden md:block" />
          with Cashfree&apos;s premier modular{" "}
          <h2 className="inline text-[24px] md:text-[28px]">escrow solution</h2>
        </h3>
      </div>
      <div>
        <div className="integration-slider-card">
          <video
            src="https://cashfreelogo.cashfree.com/website/landings/escrow-account/Desktop_EscrowProcess.mp4"
            alt="img"
            height="610"
            autoPlay
            muted
            playsInline
            loop
            className="w-ful hidden md:block m-auto"
          />
          <video
            src="https://cashfreelogo.cashfree.com/website/landings/escrow-account/Mobile_EscrowProcess.mp4"
            alt="img"
            height="610"
            autoPlay
            muted
            playsInline
            loop
            className="w-full block md:hidden"
          />
        </div>
      </div>
      <div className="md:max-w-[1258px] m-auto">
        <div className="bg-purple-small">
          <p className="md:text-[24px] text-[20px] font-semibold">
            Schedule a call with our{" "}
            <h2 className="inline md:text-[24px] text-[20px] body-text font-semibold">
              Escrow
            </h2>{" "}
            expert today and get started!
          </p>
          <a
            className="button button-green w-full md:w-[178px]"
            href="/contact-sales?source-action=One%20Escrow&action=Contact%20Sales&button-id=ContactSales_ScheduleCall">
            Schedule Call <span className="chevron" />
          </a>
        </div>
      </div>
    </section>
  );
};
export default EscrowSolution;
